
export class Category {
  id: number;
  title: string;
  img: string;
  description: string;
}
